import { trackable_data } from './trackable-data';
import { DeleteCookie } from './utils/cookie';

const NON_ESSENTIAL_GROUPS = ['C0002', 'C0003', 'C0004', 'C0005'];

// const cookieCleaningMap = {
//     C0002: ['_ga', '_gid', 'analytics_session'],
//     C0003: ['ab_test_variant', 'feature_flags'],
//     C0004: ['ad_id', 'retargeting_uid'],
// };

// const cookieMapByCategory = Object.values(trackable_data).reduce((map, entry) => {
//     if (!entry.cookie || !entry.consent_category) return map;
//     if (!map[entry.consent_category]) map[entry.consent_category] = [];
//     map[entry.consent_category].push(entry.cookie);
//     return map;
// }, {});

function getCookieNames() {
    return document.cookie
        .split(';')
        .map((s) => s.trim().split('=')[0])
        .filter(Boolean);
}

function getStorageKeys(storage) {
    if (!storage) return [];
    try {
        const out = [];
        for (let i = 0; i < storage.length; i += 1) out.push(storage.key(i));
        return out;
    } catch (e) {
        return [];
    }
}

function snapshotStorage() {
    return {
        cookies: getCookieNames(),
        localStorage: getStorageKeys(window.localStorage),
        sessionStorage: getStorageKeys(window.sessionStorage),
    };
}

function diff(before, after) {
    const set = new Set(after);
    return before.filter((k) => !set.has(k));
}

const DEBUG_FLAG_KEY = 'shipbob:consent-debug';

function isDebugEnabled() {
    try {
        if (window.__shipbobConsentDebug === true) return true;
        if (/[?&]consent_debug=1\b/.test(window.location.search)) return true;
        return window.localStorage && localStorage.getItem(DEBUG_FLAG_KEY) === '1';
    } catch (e) {
        return false;
    }
}

const recursiveObjectFromPrefix = (name, prefiex_regex, tree, payload) => {
    const parts = name.split(prefiex_regex);
    let delta_tree = tree;
    let new_tree = {};
    let current_depth = null;

    console.log(tree);

    if (parts.length > 1) {
        const [ index, ...remainder ] = parts;
        current_depth = tree[index];

        if (!current_depth) {
            new_tree = recursiveObjectFromPrefix(remainder.join('_'), prefiex_regex, new_tree, payload);
        } else {
            new_tree = recursiveObjectFromPrefix(remainder.join('_'), prefiex_regex, current_depth, payload);
        }
        
        tree[index] = new_tree;
    } else {
        const [ index ] = parts;
        tree[index] = payload;
    }

    return tree;
}

function OneTrustDataMaps() {
    try {
        if (!window.OneTrust || typeof window.OneTrust.GetDomainData !== 'function') {
            return [];
        }
        const data = window.OneTrust.GetDomainData() || {};
        const groups = data.Groups || [];

        return groups.map(({ OptanonGroupId, GroupName, Cookies, Hosts }) => ({
            group: OptanonGroupId,
            name: GroupName,
            cookies: (Cookies || []).map((c) => c.Name).filter(Boolean),
            hosts: (Hosts || []).map((h) => h.HostName),
        }));
    } catch (e) {
        return [];
    }
}

function parseActiveGroupsString(s) {
    if (!s || typeof s !== 'string') return [];
    return s.split(',').map((g) => g.trim()).filter(Boolean);
}

function logInit() {
    if (!isDebugEnabled()) return;
    console.groupCollapsed('[consent-debug] init');
    console.log('OneTrust domain data:', OneTrustDataMaps());
    console.log('window.OnetrustActiveGroups:', window.OnetrustActiveGroups);
    console.groupEnd();
}

function logCleanup(group, before, after) {
    const cleared = {
        cookies: diff(before.cookies, after.cookies),
        localStorage: diff(before.localStorage, after.localStorage),
        sessionStorage: diff(before.sessionStorage, after.sessionStorage),
    };

    console.groupCollapsed(`[consent-debug] group ${group} cleared`);
    console.log('actually cleared:', cleared);
    console.log('still present after clear:', {
        cookies: after.cookies,
        localStorage: after.localStorage,
        sessionStorage: after.sessionStorage,
    });
  
    console.groupEnd();
}

function handleConsentChanged(event) {
    const debug = isDebugEnabled();
    const rawDetail = (event && event.detail) || window.OnetrustActiveGroups || '';
    const consentedGroups = Array.isArray(rawDetail)
        ? rawDetail
        : parseActiveGroupsString(rawDetail);

    if (debug) {
        console.groupCollapsed('[consent-debug] OnConsentChanged fired');
        console.log('raw event:', event);
        console.log('event.detail:', event && event.detail);
        console.log('consentedGroups parsed as:', consentedGroups);
        console.log('window.OnetrustActiveGroups:', window.OnetrustActiveGroups);
        console.groupEnd();
    }

    const active_cookies = getCookieNames();
    const oneTrustGroups = OneTrustDataMaps();

    oneTrustGroups.forEach(({ cookies, group }) => {
        if (!NON_ESSENTIAL_GROUPS.includes(group)) return;
        if (consentedGroups.includes(group)) return;

        const before = debug ? snapshotStorage() : null;

        cookies.forEach((catalogued_cookie) => {
            // Split on runs of wildcard chars (x, X, #), escape everything else,
            // then rejoin — each wildcard run becomes .* to match any length.
            const hasWildcard = /[xX#]/.test(catalogued_cookie);
            const pattern = catalogued_cookie
                .split(/([xX#]+)/)
                .map((part) =>
                    /^[xX#]+$/.test(part)
                        ? '.*'
                        : part.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
                )
                .join('');
            // For exact (no-wildcard) entries, also match underscore-delimited
            // suffix variants so that e.g. "_ga" catches "_ga_2F14T0KJFW".
            // The separator must be "_" so "_ga" does not over-match "_gabcdef".
            const finalPattern = hasWildcard ? pattern : `${pattern}(_\\S+)*`;
            const regex_cookie = new RegExp(`^${finalPattern}$`, 'i');

            active_cookies
                .filter((incoming_cookie) => regex_cookie.test(incoming_cookie))
                .forEach(DeleteCookie);

            try {
                Object.entries(window.localStorage).forEach(([key]) => {
                    if (regex_cookie.test(key)) window.localStorage.removeItem(key);
                });
            } catch (_e) {}

            try {
                Object.entries(window.sessionStorage).forEach(([key]) => {
                    if (regex_cookie.test(key)) window.sessionStorage.removeItem(key);
                });
            } catch (_e) {}
        });

        if (debug) {
            const after = snapshotStorage();
            logCleanup(group, before, after);
        }
    });
}

function exposeDevTools() {
    window.__shipbob_consent_debug = {
        enable: () => {
            try { localStorage.setItem(DEBUG_FLAG_KEY, '1'); } catch (e) {}
            window.__shipbobConsentDebug = true;
            console.info('[consent-debug] enabled — reload to capture init logs');
        },
        disable: () => {
            try { localStorage.removeItem(DEBUG_FLAG_KEY); } catch (e) {}
            window.__shipbobConsentDebug = false;
        },
        oneTrust: OneTrustDataMaps,
        nonEssentialGroups: NON_ESSENTIAL_GROUPS,
        // all_localStorage: getStorageKeys(window.localStorage),
        // all_sessionStorage: getStorageKeys(window.sessionStorage),
        simulateConsentChange: (groups = []) => handleConsentChanged({ detail: groups }),
        // Simulate a revocation without going through OneTrust UI.
        simulateRevoke: (groups = []) => handleConsentChanged({ detail: groups }),
    };
}

export function initConsentCookieCleanup() {
    if (window.OneTrust && typeof window.OneTrust.OnConsentChanged === 'function') {
        exposeDevTools();
        window.OneTrust.OnConsentChanged(handleConsentChanged);
        logInit();
        return;
    }

    // Guard against the race where OptanonWrapper (and its onetrust-ready dispatch)
    // ran before this listener was registered. The _onetrustReady flag is set by
    // OptanonWrapper in enqueues.php; if it's already true, the event is gone and
    // the addEventListener below would never fire.
    if (window._onetrustReady) {
        setTimeout(initConsentCookieCleanup, 0);
        return;
    }

    window.addEventListener('onetrust-ready', initConsentCookieCleanup, { once: true });
}
